import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the absence state domain
 */

const selectAbsenceDomain = state => state.absence || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Absence
 */

const makeSelectItemsList = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.itemsList,
  );

const makeSelectItemsListFirstElem = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.firstElem,
    );


const selectUpdatedAbsencesLoading = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.loadingUpdatedList,
  );

const selectAbsencesLoading = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.loading,
  );

const selectAbsenceError = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.error,
  );

const selectAbsenceDeleteSuccessful = () =>
  createSelector(
    selectAbsenceDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectAbsenceDomain,
  selectAbsencesLoading,
  selectUpdatedAbsencesLoading,
  selectAbsenceError,
  selectAbsenceDeleteSuccessful,
  makeSelectItemsList,
  makeSelectItemsListFirstElem,
};
